import { ActionType } from 'reducers/app-state';
import { store } from 'store';

import {
  SHOW_LITERACY_MODAL,
  HIDE_LITERACY_MODAL,
  SET_LITERACY_RESULT,
  OFFLINE_SPINNER_ON,
  OFFLINE_SPINNER_OFF,
  GLOBAL_ERR,
  RESET_GLOBL_STATE,
  CLEAR_GLOBAL_ERR,
} from './actionTypes';

export const showLiteracyModal = (): ActionType => {
  return { type: SHOW_LITERACY_MODAL };
};

export const hideLiteracyModal = (): ActionType => {
  return { type: HIDE_LITERACY_MODAL };
};

export const setLiteracyResult = (result: boolean): ActionType => {
  return { type: SET_LITERACY_RESULT, payload: { result } };
};

export const showOfflineSpinner = (): ActionType => {
  const { userData } = store.getState().users;
  const activeUnit = userData?.activeScholarId;

  return { type: OFFLINE_SPINNER_ON, payload: { activeUnit } };
};

export const hideOfflineSpinner = (): ActionType => {
  return { type: OFFLINE_SPINNER_OFF };
};

export const setGlobalError = (globalError: string): ActionType => {
  return { type: GLOBAL_ERR, payload: { globalError } };
};

export const clearGlobalError = (): ActionType => {
  return { type: CLEAR_GLOBAL_ERR };
};

export const resetGlobalState = (): ActionType => {
  return { type: RESET_GLOBL_STATE };
};
